<div class="tire-in-out-dialog">
  <div class="tire-in-out-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-tire font-20 font-gray-45 header-icon font-white"></i>
        <div class="pl-1 tire-description width-100p p-relative">
          <p class="m-0 font-secondary-700 font-14 font-white" *ngIf="false">
            Add new tire
          </p>
          <p class="m-0 font-secondary-700 font-14 font-white">
            Tire Storage - Tires Out
          </p>
        </div>

        <i id="tire-close-dialog" class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>

  <!-- Tire storage body -->
  <div class="tire-in-out-body-wrapper">
    <div class="tire-in-out-body">
      <div class="tire-body-header-row">
        <div class="tire-body-header-row-left">
          <b class="capitalize">{{customerName}}'s</b> tires in storage for <b>{{vehicleName}}</b>
        </div>
        <div class="tire-body-header-row-right search-bar">
          <div class="search-bar-width">
            <app-input 
              placeholder="Search by TS #, tire brand, model, & size"
              theme="border"
              leftIcon="fal fa-search"
              [autoFocus]="false"
              (appChange)="handleChange($event)">

            </app-input>
            <!-- <app-auto-complete placeholder="Search by TS #, tire brand, model, & size, or vehicle"
              leftIcon="fal fa-search" field="title" theme="border" [closeOnSelection]="true" [hasEditableField]="false"
              [hasCustomEditableField]="false" [autoFocus]="false" [hasSearchIcon]="true" scrollHeight="1px">
            </app-auto-complete> -->
          </div>
        </div>
      </div>
      <!-- Table -->
      <div class="tire-body-table-row" *ngIf="!isLoading && tireData?.length">
        <p-table [value]="tireData" sortMode="single" [lazy]="true" (onSort)="_searchSuggestion('', $event)" [paginator]="false" [rows]="5" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th style="background-color: #FAFAFA" pSortableColumn="externalId">
                TS # <p-sortIcon field="externalId" />
              </th>
              <th style="background-color: #FAFAFA">Date of Storage</th>
              <th style="background-color: #FAFAFA">Tire Brand</th>
              <th style="background-color: #FAFAFA">Tire Model</th>
              <th style="background-color: #FAFAFA">Tire Size</th>
              <th style="background-color: #FAFAFA">Quantity</th>
              <th style="background-color: #FAFAFA">Action</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-tire>
            <tr>
              <td>{{ tire.tsNumber }}</td>
              <td>{{ tire.dateOfStorage }}</td>
              <td>
                <ng-container *ngFor="let groupedTire of tire?.tireGroupedInfo">
                  {{ groupedTire.tireBrand }}<br />
                </ng-container>
              </td>
              <td>
                <ng-container *ngFor="let groupedTire of tire?.tireGroupedInfo">
                  {{ groupedTire.tireModel }}<br />
                </ng-container>
              </td>
              <td>
                <ng-container *ngFor="let groupedTire of tire?.tireGroupedInfo">
                  {{ groupedTire.tireSize }}<br />
                </ng-container>
              </td>
              <td>
                <ng-container *ngFor="let groupedTire of tire?.tireGroupedInfo">
                  {{ groupedTire.quantity | number : '2.0'}}<br />
                </ng-container>
              </td>
              <td (click)="addTireStorageToRo(tire)" class="pointer">
                <b class="font-primary">
                  Add to RO for return
                </b>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="flex-center-center" *ngIf="!tireData?.length || isLoading">
        <i class="fa fa-spinner rotate" *ngIf="isLoading"></i>
        <span *ngIf="!isLoading && !tireData?.length">No record found</span>
      </div>
    </div>
  </div>
</div>
